import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { InventoryService,MasterService } from '../../services/index';

@Component({
  selector: 'app-itmchk',
  templateUrl: './itmchk.component.html',
  styleUrls: ['./itmchk.component.scss'],
    providers:[InventoryService,MasterService]
})
export class ItmchkComponent implements OnInit {

   closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    arritems:any=[];
    arrmjgrp:any=[];
    arrmngrp:any=[];
    itemmodel:any={};
    tab=1;
  
    status = [
      {
        id: 1,
        name: 'Active'
      },
      {
        id: 2,
        name: 'Inactive'
      }
   ];
  
  
   
    statusyn = [
      {
        id: 1,
        name: 'Yes'
      },
      {
        id: 2,
        name: 'No'
      }
   ];
    arrinvmmfr: any;
    arrinvmunit: any;
    arrinvtax: any;
  arraccat: any;
  arrtmph: any;
  pays:any={}
  arrvocdet: any=[];
  tmrp: any;
  tsqty: any;
  tsrate: any;
  arrtmpd: any;
  istpid: any;
  objitm: any;
  filteredCountries: any[];
    constructor(private mservice:MasterService,private iservice: InventoryService,private modalService: NgbModal) { }
  
    openmodal(content) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
    ngOnInit(): void {
      this.getinvtisutmph();
      this.getinvmitem();
      this.masacccat();
      this.masclass();
      this.mascourse();
    
      
  
    }
  

    addacchead()
{
  console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrvocdet.push({itid:'1',mrp:'0',prate:'0',srate:'0',sqty:'0',sort:'0'});
console.log('arrvoc1',this.arrvocdet);

//$scope.payRows.push({});
}

remaddacchead(ind)
{
//alert(ind);
this.arrvocdet.splice(ind,1);
}

 getmrptotal()
    {
      debugger
 this.tmrp=this.arrvocdet.map((a:any) => a.mrp).reduce(function (a:any, b:any) {
      return a + b;
    });
    
  }

   getpratetotal()
    {
      debugger
 this.tsrate=this.arrvocdet.map((a:any) => a.prate).reduce(function (a:any, b:any) {
      return a + b;
    });
    
  }

   getsratetotal()
    {
      debugger
 this.tsrate=this.arrvocdet.map((a:any) => a.srate).reduce(function (a:any, b:any) {
      return a + b;
    });
    
  }

   getsqtytotal()
    {
      debugger
 this.tsqty=this.arrvocdet.map((a:any) => a.sqty).reduce(function (a:any, b:any) {
      return a + b;
    });
    
  }


    masclass() {
      this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arrmjgrp = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }
      masacccat() {
      this.mservice.masacccat()
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arraccat = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }

     mascourse() {
      this.mservice.mascourse()
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arrmngrp = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }
   
    getinvmitem() {
      this.iservice.getinvmitem()
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arritems = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }

    filterCountry(event) {
  debugger
        let filtered: any[] = [];
        let query = event.query;
        
        for (let i = 0; i < (this.arritems as any[]).length; i++) {
            let country = (this.arritems as any[])[i];
            // if (country.itnm.toLowerCase().indexOf(query.toLowerCase()) == 0) {
             if (country.itnm.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(country);
            }
        }
        this.filteredCountries = filtered;
    }


    getinvtisutmph() {
      this.iservice.getinvtisutmph()
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arrtmph = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }
    opendialog(content,objdata,cmd) {
      if(cmd=='insert')
      {
        this.itemmodel={};
        this.itemmodel.istpid=0;
      
        this.itemmodel.crid=this.arrmngrp[0].crid || '';
        this.itemmodel.clid=this.arrmjgrp[0].clid || '';
         this.itemmodel.accatid=this.arraccat[0].accatid || '';
       
        this.itemmodel.oprtype='insert';
        
  
      }
  
      else if(cmd=='update')
      {
        this.itemmodel=objdata;
        this.itemmodel.mdby=localStorage.getItem('usid');
        this.itemmodel.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    saveinvtisutmph()
    {
  console.log('catsave',this.itemmodel);
      this.iservice.saveinvtisutmph(this.itemmodel)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
                this.getinvtisutmph();
                //this.getlibcategory();
  
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }


     openitmdlg(content,objdata,cmd) {
      debugger
  this.istpid=objdata.istpid;
      this.getinvtisutmpd(this.istpid);
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


      openedit(content,objdata) {
      debugger
  this.objitm=objdata;
      this.getinvtisutmpd(this.istpid);
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }

    getinvtisutmpd(isid) {
      this.iservice.getinvtisutmpd(isid)
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arrtmpd= resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }


    saveinvtisutmpd()
    {
  // console.log('catsave',this.itemmodel);
    // $istpid=$data['istpid'];

    const ownerCarMakes = this.arrvocdet.map(owner => {
  
  owner.itid=owner.itmid.itid;
  return owner;
});
console.log('ownerCarMakes',ownerCarMakes);
  var pst={istpid:this.istpid,issuedtls:ownerCarMakes,oprtype:"insert"};
      this.iservice.saveinvtisutmpd(pst)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                // let localmodref=this.modalRef;
                // localmodref.close();
                this.arrvocdet=[];
                this.getinvtisutmpd(this.istpid);
                //this.getlibcategory();
  
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }


    deleteitem(rid)
    {
  // console.log('catsave',this.itemmodel);
    // $istpid=$data['istpid'];
    if(confirm('Are you sure to delete this item ?'))
    {
  var pst={istpid:rid,issuedtls:{},oprtype:"delete"};
      this.iservice.saveinvtisutmpd(pst)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                
              
                this.getinvtisutmpd(this.istpid);
                //this.getlibcategory();
  
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }
  }


   updateitem()
    {

  this.objitm.oprtype='update';
      this.iservice.saveinvtisutmpd( this.objitm)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
              
                this.getinvtisutmpd(this.istpid);
                //this.getlibcategory();
  
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
  
  }

  }
  
